import type { IncomingContact } from '../connect/ccp.js';

/**
 * Full-width alert shown while a contact is being offered to the agent. The
 * workspace plays a looping ringtone alongside this banner (see ringtone.ts);
 * both stop when the agent Accepts (answers) or Rejects (returns it to the queue
 * for another rep).
 */
export function IncomingContactAlert({
  incoming,
  busy,
  onAccept,
  onReject,
}: {
  incoming: IncomingContact;
  busy: boolean;
  onAccept: () => void;
  onReject: () => void;
}) {
  const isChat = incoming.channel === 'chat';
  const attrs = incoming.attributes;
  const customer = attrs.customer_email || attrs.customer_name || 'A visitor';
  const source = attrs.source_domain;
  const label = isChat ? 'Incoming chat' : `Incoming ${incoming.channel}`;

  return (
    <div className="incoming-alert" role="alert" aria-live="assertive">
      <span className="incoming-alert__pulse" aria-hidden="true" />
      <div className="incoming-alert__body">
        <div className="incoming-alert__title">
          <span className={`badge ${isChat ? 'badge--chat' : 'badge--voice'}`}>{label}</span>
          <strong>{customer} is waiting to chat</strong>
        </div>
        <div className="incoming-alert__meta">
          {source ? `From ${source}` : 'A customer is waiting for an agent.'}
        </div>
      </div>
      <div className="incoming-alert__actions">
        <button
          type="button"
          className="btn btn--primary"
          onClick={onAccept}
          disabled={busy}
        >
          Accept
        </button>
        <button
          type="button"
          className="btn btn--danger"
          onClick={onReject}
          disabled={busy}
          title="Return this chat to the queue for another representative"
        >
          Reject
        </button>
      </div>
    </div>
  );
}
